import type { EventTypeCountStats } from '../../services/widget-analytics';

export type AnalyticsEventType =
  | `${EventTypeCountStats.eventType}`
  | 'CLOSED_WIDGET_SHOWN'
  | 'DYNAMIC_GREETING_BUTTON_PRESSED'
  | 'DYNAMIC_WIDGET_RECONNECTED'
  | 'DYNAMIC_WIDGET_STARTED'
  | 'STATIC_WIDGET_VIDEO_CHAT_BUTTON_PRESSED';

export const eventTypeLabels: Record<AnalyticsEventType, string> = {
  STATIC_WIDGET_CLOSED: 'Static Widget Closed',
  STATIC_WIDGET_OPENED: 'Static Widget Opened',
  STATIC_WIDGET_SHOWN: 'Static Widget Shown',
  DYNAMIC_WIDGET_CLOSED: 'Dynamic Widget Closed',
  DYNAMIC_WIDGET_OPENED: 'Dynamic Widget Opened',
  DYNAMIC_WIDGET_SHOWN: 'Dynamic Widget Shown',
  DYNAMIC_WIDGET_STARTED: 'Dynamic Widget Started',
  STATIC_WIDGET_VOICE_CHAT_BUTTON_PRESSED: 'Voice Chat Button Pressed (Static)',
  STATIC_WIDGET_TEXT_CHAT_BUTTON_PRESSED: 'Text Chat Button Pressed (Static)',
  STATIC_WIDGET_SETTINGS_REQUESTED: 'Static Widget Settings Requested',
  DYNAMIC_WIDGET_SETTINGS_REQUESTED: 'Dynamic Widget Settings Requested',
  STATIC_WIDGET_VIDEO_CHAT_BUTTON_PRESSED: 'Video Chat Button Pressed (Static)',
  USER_STAYED_ON_PAGE_WITH_STATIC_WIDGET_FOR_X_SECONDS:
    'User Stayed on Page (Static Widget)',

  CLOSED_WIDGET_SHOWN: 'Closed Widget Shown',
  DYNAMIC_GREETING_BUTTON_PRESSED: 'Dynamic Greeting Button Pressed',
  DYNAMIC_WIDGET_RECONNECTED: 'Dynamic Widget Reconnected',
};
